import { RESET_STATE_ACTION } from '../types';
import { createAction, PayloadAction } from '@reduxjs/toolkit';
import { createSlice } from '../utils';
import {
  AvailableInstallationDates,
  initialScheduleInstallationState,
  ScheduleInstallationState,
  SelectedInstallation,
} from './types';
import { ScheduleR0 } from '@buy-viasat/types/build/bv';

const scheduleInstallationSlice = createSlice({
  name: 'scheduleInstallation',
  initialState: initialScheduleInstallationState,
  reducers: {
    getInstallationDates(state: ScheduleInstallationState, action: PayloadAction<string>) {
      state.loadingInstallationDates = true;
    },
    getInstallationDatesError(state: ScheduleInstallationState): void {
      state.loadingInstallationDates = false;
      state.availableInstallationDates = {} as AvailableInstallationDates;
    },
    setInstallationDatesLoading(state: ScheduleInstallationState): void {
      state.loadingInstallationDates = true;
    },
    installationDatesLoadingComplete(state: ScheduleInstallationState): void {
      state.loadingInstallationDates = false;
    },
    setToday(state: ScheduleInstallationState, action: PayloadAction<Date>): void {
      const day = action.payload.getDate();
      const month = action.payload.getMonth() + 1;
      const year = action.payload.getFullYear();
      state.today = { month, day, year };
      state.calendarDate = { month, year };
    },
    setSelectedInstallation(state: ScheduleInstallationState, action: PayloadAction<SelectedInstallation>): void {
      state.selectedInstallation.value = action.payload;
    },
    setAvailableInstallationDates(
      state: ScheduleInstallationState,
      action: PayloadAction<AvailableInstallationDates>,
    ): void {
      state.loadingInstallationDates = false;
      state.availableInstallationDates = action.payload;
    },
    setHasSubmittedScheduleInstall(state: ScheduleInstallationState, action: PayloadAction<boolean>): void {
      state.hasSubmittedScheduleInstall = action.payload;
    },
    resetInstallationDates(state: ScheduleInstallationState): void {
      state.selectedInstallation = initialScheduleInstallationState.selectedInstallation;
    },
    setPALInstallationDates(state: ScheduleInstallationState, action: PayloadAction<ScheduleR0[]>): void {
      state.PALInstallationDates = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(resetState, (): ScheduleInstallationState => initialScheduleInstallationState);
  },
});

const resetState = createAction(RESET_STATE_ACTION.type);

export const {
  actions: scheduleInstallationActions,
  reducer: scheduleInstallationReducer,
  name: scheduleInstallationKey,
} = scheduleInstallationSlice;
